/**
 * @fileoverview Defines the `ScrollToTop` component, which scrolls the window to the top on route changes using `useLocation` and `useEffect`. It checks `localStorage` to conditionally disable this behavior. Includes a development-only `window.toggleScrollToTop` function.
 */

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Component that scrolls the window to the top whenever the pathname changes
 */
const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    if (localStorage.getItem('disableScrollToTop') === 'true') return
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

export default ScrollToTop

declare global {
  interface Window {
    toggleScrollToTop: () => void
  }
}

if (import.meta.env.DEV) {
  window.toggleScrollToTop = () => {
    const current = localStorage.getItem('disableScrollToTop') === 'true'
    localStorage.setItem('disableScrollToTop', (!current).toString())
    console.log('Scroll to top is ' + (current ? 'enabled' : 'disabled'))
  }
}
